import Axios from 'axios'
import {getCookie, graphQLURL, graphQLToken} from '../../utils/common';
export const SET_CALENDER_ITEMS = 'calenders:getCalenderItems'
export const SET_CALENDER_ITEMS_FETCHING = 'categories:getCalenderItems:fetching'

export const setCalenderList = (calendartemps: Object[]) => ({
  type: SET_CALENDER_ITEMS,
  payload: { calendarItems: calendartemps }
})

export const fetchCalenderItems = (dispatch: Function) => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  dispatch({
    type: SET_CALENDER_ITEMS_FETCHING,
    payload: true,
  })

  const query = {
    query: `
            query {
              calendartemps {
                id
                status
                createdAt
                updatedAt
                title 
                calendarstartdate
                calendarenddate 
                description
              }
            }`
  }
    const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    Axios.post(apiUrl, query, CONTENT_TYPE)
    .then(function (response) {
      if (response && response.data && response.data.data && response.data.data.calendartemps) {
        dispatch(setCalenderList(response.data.data.calendartemps || []))
      }
      dispatch({
        type: SET_CALENDER_ITEMS_FETCHING,
        payload: false,
      })
    })
    .catch(function (error) {
      console.log("error",error);
      dispatch({
        type: SET_CALENDER_ITEMS_FETCHING,
        payload: false,
      })
    });
}

export const fetchCalenderRequest = async () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  const query = {
    query: `
            query {
              calendartemps {
                id
                status
                createdAt
                updatedAt
                title
                url
                calendarstartdate
                calendarenddate
                description
              }
            }`
  }
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  const response = await Axios.post(apiUrl, query, CONTENT_TYPE).catch(err => {
    return null;
  });
  if (response && response.data && response.data.data && response.data.data.calendartemps) {
    return response.data.data.calendartemps || []
  }
  return null;
}


// WEBPACK FOOTER //
// ./src/actions/calenders/index.js